import { useAuthStore } from '../store/authStore'
import { authApi } from '../api/authApi'

export function useAuth() {
  const { user, token, isLoggedIn, setAuth, logout } = useAuthStore()

  /** Called after Google sign-in to exchange for our internal JWT. */
  async function signInWithGoogle(googleIdToken: string): Promise<void> {
    const response = await authApi.googleSignIn(googleIdToken)
    setAuth(
      { userId: response.userId, name: response.name, email: response.email },
      response.token,
    )
  }

  return { user, token, isLoggedIn, signInWithGoogle, logout }
}
